import React, { useState } from 'react';
import { Mail, Copy, Check, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { cn } from '../../../lib/utils';

const ContactSupport = ({ userInfo }) => {
  const [copied, setCopied] = useState(false);
  const supportEmail = 'ope@trysixth.com';

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = supportEmail;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex-1 bg-[#0a0a0f] p-8 overflow-y-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2">Contact Support</h1>
        <p className="text-sm text-muted-foreground">Get help with your account or technical issues</p>
      </div>

      <div className="max-w-2xl">
        <Card className="bg-[#121219]/80 border-white/10">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Mail className="w-5 h-5 text-primary" />
              <CardTitle>Email Support</CardTitle>
            </div>
            <CardDescription>
              Send us an email and we'll respond within 24 hours during business days.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-black/40 border border-white/10 rounded-lg p-4 flex items-center justify-between">
              <code className="text-sm text-white font-mono">{supportEmail}</code>
              <Button 
                variant="ghost" 
                size="sm"
                onClick={copyToClipboard}
                className={cn(
                  "h-8 gap-2 transition-colors",
                  copied ? "text-green-500 hover:text-green-600 hover:bg-green-500/10" : "text-primary hover:text-primary/80 hover:bg-primary/10"
                )}
              >
                {copied ? (
                  <>
                    <Check className="w-4 h-4" /> Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4" /> Copy
                  </>
                )}
              </Button>
            </div>

            <Button 
              className="w-full gap-2"
              onClick={() => window.open(`mailto:${supportEmail}`)}
            >
              <ExternalLink className="w-4 h-4" /> Open Mail App
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ContactSupport;
